import { useRef, useState } from 'react';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import styles from './maskGalleryView.module.scss';
// eslint-disable-next-line import/no-unresolved
import '@splidejs/react-splide/css';

export const MaskGalleryView = ({
	maskImages
}) => {
	const mainSplideRef = useRef(null);
	const thumbnailSplideRef = useRef(null);
	const [currentIndex, setCurrentIndex] = useState(0);

	const handleMainSlideMove = (splide) => {
		setCurrentIndex(splide.index);
	};

	const handleThumbnailClick = (index) => {
		if (mainSplideRef.current) {
			mainSplideRef.current.go(index);
		}
	};

	return (
		<>
			<div className={styles.mainSliderContainer}>
				<Splide
					ref={mainSplideRef}
					options={{
						type: 'loop',
						perPage: 1,
						arrows: false,
						pagination: false,
						drag: true,
						gap: '1rem',
						autoHeight: false,
						height: '100%'
					}}
					onMove={handleMainSlideMove}
					onMounted={(splide) => {
						mainSplideRef.current = splide;
						if (thumbnailSplideRef.current) {
							splide.sync(thumbnailSplideRef.current);
						}
					}}
				>
					{maskImages.map((image) => (
						<SplideSlide key={image}>
							<div className={styles.mainImageWrapper}>
								<img src={image.image_url} className={styles.mainImage} alt='' />
							</div>
						</SplideSlide>
					))}
				</Splide>
				<button
					onClick={() => mainSplideRef.current?.go('<')}
					className={`${styles.navButton} ${styles.navButtonLeft}`}
					aria-label="Previous image"
				>
					<ChevronLeft size={28} />
				</button>

				<button
					onClick={() => mainSplideRef.current?.go('>')}
					className={`${styles.navButton} ${styles.navButtonRight}`}
					aria-label="Next image"
				>
					<ChevronRight size={28} />
				</button>
			</div>
			<div className={styles.thumbnailSliderContainer}>
				<Splide
					ref={thumbnailSplideRef}
					options={{
						fixedWidth: 80,
						fixedHeight: 80,
						gap: '12px',
						rewind: false,
						pagination: false,
						isNavigation: true,
						focus: 'center',
						drag: true,
						arrows: false,
						updateOnMove: true
					}}
					onMounted={(splide) => {
						thumbnailSplideRef.current = splide;
						if (mainSplideRef.current) {
							mainSplideRef.current.sync(splide);
						}
					}}
					className={styles.thumbnailSlider}
				>
					{maskImages.map((image, index) => (
						<SplideSlide
							style={{
								border: 0
							}}
							key={image}>
							<button
								onClick={() => handleThumbnailClick(index)}
								className={`${styles.thumbnail} ${index === currentIndex ? styles.thumbnailActive : ''}`}
							>
								<img src={image.image_url} alt='' />
								{index === currentIndex && <div className={styles.thumbnailOverlay} />}
							</button>
						</SplideSlide>
					))}
				</Splide>
				<div className={styles.gradientLeft} />
				<div className={styles.gradientRight} />
			</div>
		</>
	);
};
